// ThemeContext.tsx
import { createContext, useMemo, useState, ReactNode } from 'react';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import DarkTheme from '../themes/DarkTheme';
import DefaultTheme from '../themes/DefaultTheme';
import { CssBaseline } from '@mui/material';

export type ThemeMode = 'light' | 'dark';

interface ThemeContextProps {
  mode: ThemeMode;
  toggleMode: () => void;
}

export const ThemeContext = createContext<ThemeContextProps>({
  mode: 'light',
  toggleMode: () => { },
});

export const CustomThemeProvider = ({ children }: { children: ReactNode }) => {
  const [mode, setMode] = useState<ThemeMode>('light');

  const toggleMode = () => setMode(prev => (prev === 'light' ? 'dark' : 'light'));

  return (
    <ThemeContext.Provider value={{ mode, toggleMode }}>
      <ThemeProvider theme={mode === "light" ? DefaultTheme : DarkTheme}>{children}</ThemeProvider>
    </ThemeContext.Provider>
  );
};
